import { render, staticRenderFns } from "./job-form-layout.vue?vue&type=template&id=3af51a73"
import script from "./job-form-layout.vue?vue&type=script&lang=js"
export * from "./job-form-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports